import React, { useState } from "react";
import axios from "axios";
import { API_URL } from "../../api-config";
import { useNavigate } from "react-router-dom";

const UploadReport = () => {
  const [file, setFile] = useState(null);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [uploading, setUploading] = useState(false);
  const token = localStorage.getItem("token");
  const navigate = useNavigate();

  const handleFileChange = (e) => {
    const selected = e.target.files[0];
    if (selected && selected.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
      setFile(selected);
      setError("");
    } else {
      setFile(null);
      setError("Solo se permiten archivos .xlsx");
    }
  };

  const handleUpload = async () => {
    if (!file) {
      setError("Selecciona un archivo válido primero.");
      return;
    }

    setUploading(true);
    setMessage("");
    setError("");

    const formData = new FormData();
    formData.append("file", file);

    try {
      await axios.post(`${API_URL}/trading-api/reports/upload_report`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      });
      setMessage("Archivo subido correctamente.");
      setFile(null);
      setTimeout(() => navigate("/"), 2000); // redirige después de 2 seg
    } catch (err) {
      setError("Error al subir el archivo.");
      console.error(err);
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="p-8 max-w-xl mx-auto bg-[#101523] min-h-screen text-white space-y-6">
      <h2 className="text-2xl font-bold">Subir nuevo reporte</h2>

      <input
        type="file"
        accept=".xlsx"
        onChange={handleFileChange}
        className="block w-full text-sm text-gray-300 file:mr-4 file:py-2 file:px-4 file:rounded file:border-0 file:text-sm file:font-semibold file:bg-blue-600 file:text-white hover:file:bg-blue-700"
      />

      {file && (
        <p className="text-sm text-green-400">Archivo seleccionado: {file.name}</p>
      )}

      {error && <p className="text-sm text-red-400">{error}</p>}
      {message && <p className="text-sm text-green-400">{message}</p>}

      <button
        onClick={handleUpload}
        disabled={uploading || !file}
        className="bg-blue-600 hover:bg-blue-700 disabled:opacity-50 text-white font-semibold px-4 py-2 rounded"
      >
        {uploading ? "Subiendo..." : "Subir reporte"}
      </button>
    </div>
  );
};

export default UploadReport;
